import { routes as app } from '../app/index';

const root = [];

const notFound = {
  path: '*',
  redirect: '/',
};

export default [...root, ...app, notFound];
